class AddOnCard extends HTMLElement {
  connectedCallback() {
    this.images = this.querySelectorAll('[data-image-variant-id]');
    this.addEventListener('change', this.onChange);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
    this.removeEventListener('click', this.onClick);
  }

  onChange = (event) => {
    const select = event.target.closest('.add-on-select');
    if (!select) return;

    event.stopPropagation();
    this.dataset.variantId = select.value;
    this.images.forEach((image) => {
      image.hidden = image.dataset.imageVariantId !== select.value;
    });
  };

  onClick = (event) => {
    if (!event.target.closest('[data-add-to-cart]')) return;

    event.preventDefault();
    $s.showLoadingOverlay();
    $s.post({
      url: routes.cart_url + '/add.js',
      data: new URLSearchParams({ id: this.dataset.variantId, quantity: 1 }).toString(),
      success: () => {
        $s.addToCartSuccess();
      },
      error: (response) => {
        $s.addToCartFail(response.description);
      },
    });
  };
}

if (!customElements.get('add-on-card')) {
  customElements.define('add-on-card', AddOnCard);
}
